import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import {DotsIntegerPipe} from './dots-integer.pipe';
import {DayOfWeekPipe} from './day-of-week.pipe';
import { CurrencySymbolPipe } from './currency-symbol.pipe';
import { HourToDatePipe } from './hour-to-date.pipe';
import { UserFullNamePipe } from './user-full-name.pipe';
import {Number2wordsPipe} from './number2words.pipe';
import {UserFullNameWithDocumentPipe} from './user-full-name-with-document.pipe';
import {PluckPipe} from './pluck.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    SearchPipe,
    ShortNamePipe,
    DotsIntegerPipe,
    DayOfWeekPipe,
    CurrencySymbolPipe,
    HourToDatePipe,
    UserFullNamePipe,
    Number2wordsPipe,
    UserFullNameWithDocumentPipe,
    PluckPipe,
  ],
  imports: [CommonModule],
  exports: [
    FilterPipe,
    SearchPipe,
    ShortNamePipe,
    DotsIntegerPipe,
    DayOfWeekPipe,
    CurrencySymbolPipe,
    HourToDatePipe,
    UserFullNamePipe,
    Number2wordsPipe,
    UserFullNameWithDocumentPipe,
    PluckPipe
  ]
})

export class PipeModule {}
